type TempItem = { text: string };
export function hasDuplicateKeywords(temp: TempItem[]): boolean {
  const texts = temp.map(item => item.text.trim().toLowerCase());
  return new Set(texts).size !== texts.length;
}
